import { render, staticRenderFns } from "./RecognitionS.vue?vue&type=template&id=a095e500&scoped=true"
import script from "./RecognitionS.vue?vue&type=script&lang=js"
export * from "./RecognitionS.vue?vue&type=script&lang=js"
import style0 from "./RecognitionS.vue?vue&type=style&index=0&id=a095e500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a095e500",
  null
  
)

export default component.exports